export function whatsappContactId(contact) {
  return contact?.contact_id || contact?.id;
}
export function mergeWhatsappConversations(zapiItems, metaItems) {
  const byContact = new Map();
  [...(zapiItems || []), ...(metaItems || [])].forEach((item) => {
    const id = whatsappContactId(item);
    if (!id) return;
    const current = byContact.get(String(id));
    if (!current) {
      byContact.set(String(id), { ...item, providers: [item.provider || 'zapi'] });
      return;
    }
    const itemTime = item.last_message_at ? new Date(item.last_message_at).getTime() : 0;
    const currentTime = current.last_message_at ? new Date(current.last_message_at).getTime() : 0;
    const latest = itemTime > currentTime ? item : current;
    byContact.set(String(id), {
      ...current,
      ...latest,
      unread_count: Number(current.unread_count || 0) + Number(item.unread_count || 0),
      channel_count: Number(current.channel_count || current.instance_count || 0)
        + Number(item.channel_count || item.instance_count || 0),
      providers: [...new Set([...(current.providers || []), item.provider || 'zapi'])],
    });
  });
  return [...byContact.values()].sort((a, b) =>
    (b.last_message_at ? new Date(b.last_message_at).getTime() : 0)
    - (a.last_message_at ? new Date(a.last_message_at).getTime() : 0));
}

export function mergeWhatsappMessages(zapiItems, metaItems) {
  return [
    ...(zapiItems || []).map((item) => ({ ...item, provider: item.provider || 'zapi' })),
    ...(metaItems || []).map((item) => ({ ...item, provider: 'meta' })),
  ].sort((a, b) => {
    const time = new Date(a.occurred_at).getTime() - new Date(b.occurred_at).getTime();
    return time || String(a.id).localeCompare(String(b.id));
  });
}

export function mapMetaChannelsForComposer(items) {
  return (items || []).map((channel) => ({
    ...channel,
    id: channel.channel_key || `meta:${channel.id}`,
    meta_channel_id: channel.id,
    connected: channel.is_active && Boolean(channel.token_configured) && !channel.token_expired,
    provider: 'meta',
  }));
}

export function preferredWhatsappInstanceId(messages, availableInstances, contactId) {
  const allowed = new Set((availableInstances || []).map((instance) => String(instance.id)));
  const inbound = (messages || [])
    .filter((message) => String(message.contact_id) === String(contactId)
      && message.direction === 'inbound'
      && allowed.has(String(message.instance_id)))
    .sort((left, right) => new Date(right.occurred_at).getTime() - new Date(left.occurred_at).getTime());
  return inbound.length ? String(inbound[0].instance_id) : '';
}
